import React from "react";
import { LessonCard } from "./LessonCard/LessonCard";
import { PathCard } from "./PathCard/PathCard";
import { AssessmentCard } from "./AssessmentCard/AssessmentCard";
import { ContentCardProps } from "./contentCardTypes";

export const ContentCard: React.FC<ContentCardProps> = props => {
  if (props.contentType === "path") {
    return <PathCard {...props} />;
  }

  if (props.contentType === "quest") {
    return <PathCard {...props} pathType="Quest" />;
  }

  if (props.contentType === "assessment") {
    return <AssessmentCard variant={props.variant} />;
  }

  return <LessonCard {...props} />;
};
